export default {
  meta: {
    public: false,
    auth: true,
    icon: "fa-gift",
    expanded: false,
    label: "Promotion",
    permission: [
      config.permission.PROMOTION_INDEX
    ]
  },
  children: [
    {
      name: "Discount",
      path: "/discounts",
      meta: {
        label: "Discount Codes",
        auth: true,
        breadcrumb: [{ name: "Discounts" }],
        permission: [config.permission.DISCOUNTS_INDEX]
      },
      component: () => import("views/discounts/index")
    },
    {
      name: "discount_edit",
      path: "/discounts/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Discounts", link: "/discounts" }]
      },
      component: () => import("views/discounts/edit")
    },
    {
      name: "discount_create",
      path: "/discounts/create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [
          { name: "Discounts", link: "/discounts" },
          { name: "Create" }
        ]
      },
      component: () => import("views/discounts/create")
    },
    {
      name: "discount_order_usage",
      path: "/discounts/order-usage/:id",
      meta: {
        auth: true,
        label: "Orders Using Discount",
        breadcrumb: [
          { name: "Discounts", link: "/discounts" },
          { name: "Detail" },
          { name: "Orders Usage" }
        ]
      },
      component: () => import("views/discounts/order_usage")
    },
    {
      name: "reward_history",
      path: "/referral/reward/history",
      meta: {
        auth: true,
        label: "Referrals Program",
        breadcrumb: [{ name: "Referrals Program" }]
      },
      component: () => import("views/referral/reward/index")
    },
    {
      name: "reward_edit",
      path: "/referral/reward/edit/:id",
      meta: {
        auth: true,
        label: "Referral Program ",
        breadcrumb: [{ name: "Referrals Program", link: "/referral/reward" }]
      },
      component: () => import("views/referral/reward/edit"),
      props: true
    },
    {
      name: "reward_index",
      path: "/referral/reward",
      meta: {
        auth: true,
        label: "Referrals Program",
        breadcrumb: [{ name: "Referrals Program" }],
        permission: [config.permission.REFERRALS_INDEX]
      },
      component: () => import("views/referral/reward/index")
    },
    {
      name: "reward_create",
      path: "/referral/reward/create",
      meta: {
        auth: true,
        label: "Create ",
        breadcrumb: [
          { name: "Referrals Program", link: "/referral/reward" },
          { name: "Create" }
        ]
      },
      component: () => import("views/referral/reward/create")
    }
  ]
};
